<template>
	<div class = "pay-phone-detail-div">
		<div class = "pay-phone-cell-div">
			<van-field v-model="phone"  :disabled="sUserInfo.mobile!=null && sUserInfo.mobile.length == 11" type="digit" label="文本" input-align="right" placeholder="请输入手机号"  maxlength="11">
				<template #label>
				  <div class = "pay-phone-div">
					 <div>联系电话</div>
					 <div>用于接收取餐口令</div>
				  </div>
				</template>
			</van-field>
		</div>
		
		<PhoneCode v-if="!sUserInfo.mobile" @setCode = "updateCode" :phone = "phone" @success="success"></PhoneCode>
		<div class="take-foot-div">
		   <van-cell title="就餐方式" value="到店取餐" />
		</div>
	</div>
</template>

<script>
	import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
	import PhoneCode from './PhoneCode.vue'
	
	import {Col, Row,Field,Cell,CellGroup} from 'vant';
	export default {
		name: 'Phone',
		computed: mapGetters(["sUserInfo"]),
		components: {
		      [Col.name]: Col,
		      [Row.name]: Row,
		      [Field.name]: Field,
		      [PhoneCode.name]: PhoneCode,
		      [Cell.name]: Cell,
		      [CellGroup.name]: CellGroup,
			  
		 },
		data(){
			return {
				phone:'',
				code:''
			}
		},
		created() {
			this.getPhone();
		},
		methods:{
			success(){
				this.$emit('success')
			},
			getPhone(){
				this.phone = this.sUserInfo.mobile;
			},
			updateCode(code){
				this.code = code
			},
		}
	}
</script>
	
<style scoped>
	.pay-code-div,.pay-phone-cell-div,.take-foot-div {
		border-radius: 5px;
	}
	
	.pay-phone-detail-div>div {
		background-color: #ffffff;
		margin-top: 10px;
		padding: 10px 0;
	}
	
	.pay-phone-div>div:first-child {
		color: #2d2d2d;
		font-size: 15px;
	}
	.pay-phone-div>div:last-child {
		color: #888888;
		font-size: 13px;
	}
	
	
	.pay-phone-cell-div .van-field__body{
		height:auto;
	}
	
	.pay-phone-cell-div .van-field__body input{
		font-size: 15px;
		font-weight: 500;
		height: 18px;
		margin-top: 10px;
	}

    .pay-phone-cell-div /deep/ .van-field__control:disabled {
		color: #2d2d2d;
		-webkit-text-fill-color:#2d2d2d;
	}
	
	
	
	.take-foot-div .van-cell__title {
		color: #2d2d2d;
		font-size: 15px;
	}
	
	.pay-phone-cell-div /deep/ .van-field__label {
		width: auto;
	}
</style>
